"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  max-width: 400px;\n  margin: 0 auto;\n  padding: ", ";\n  flex-direction: row;\n  align-items: flex-start;\n  justify-content: ", ";\n  svg {\n    width: ", ";\n    margin: ", " ", " 0 0;\n    color: #ff0000;\n    fill: #ff0000;\n  }\n  > div {\n    margin: 0;\n    flex-grow: 1;\n  }\n  h2 {\n    margin-bottom: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorIndicator = void 0;

var lib_1 = require("@ant-design/icons/lib");

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Typography_1 = require("./Typography");

var Container = styled_components_1.default.div(_templateObject(), function (props) {
  return props.isCompact ? '10px' : '30px';
}, function (props) {
  return props.isCompact ? 'center' : 'flex-start';
}, function (props) {
  return props.isCompact ? '20px' : '50px';
}, function (props) {
  return props.theme['@size-xxs'];
}, function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme['@size-xs'];
});

var ErrorIndicator = function ErrorIndicator(_ref) {
  var isCompact = _ref.isCompact;
  var content = isCompact ? react_1.default.createElement(lib_1.ExclamationCircleFilled, null) : react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(lib_1.ExclamationCircleFilled, null), react_1.default.createElement("div", null, react_1.default.createElement(Typography_1.H2, null, "Oh dear!"), react_1.default.createElement(Typography_1.Body, null, "Something went very wrong. Try again, and if the issue keeps happening, contact support.")));
  return react_1.default.createElement(Container, {
    children: content
  });
};

exports.ErrorIndicator = ErrorIndicator;